import React, { useRef } from 'react';
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'

import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_cg6h0bb', 'template_t3h44x9', form.current, '9Wik25qREwYJSZQ5j')
      .then((result) => {
        alert("Completed.");
        e.target.reset();
      }, (error) => {
        alert(error.text);
          console.log(error.text);
      });
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'></MdOutlineEmail>
            <h4>Email</h4>
            <h5>choi.sean1991@gmail.com</h5>
            <a href="mailto:choi.sean1991@gmail.com" target="_blank">Send a message</a>
          </article>

          <article className='contact__option'>
            <RiMessengerLine className='contact__option-icon'></RiMessengerLine>
            <h4>Messenger</h4>
            <h5>Sean Choi</h5>
            <a href="https://m.me/choisean1991" target="_blank">Send a message</a>
          </article>

        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Full Name' required />
          <input type="email" name='email' placeholder='Email' required />
          <textarea name="message" id="" rows="7" placeholder='Message' required></textarea>
          <div className='cta'>
            <button type='submit' className='btn btn-primary'>Send Message</button>
          </div>
          



        </form>








      </div>
    </section>
  )
}

export default Contact